import { index as getList, contractsBalance } from "~/api/contract";
import * as types from "../mutation-types";
import { setDefaultContract, getDefaultContract } from "~/api/user";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";


export const state = {
  contracts: null,
  joined: null,
  contractsBalance: null,
  isLoad: false,
  activeContract: null,
  isInitialLoadPending: true
};


export const mutations = {
  [types.SET_CONTRACT](state, contracts) {
    state.list = contracts.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_JOINED_CONTRACT](state, contracts) {
    state.joined = contracts.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_CONTRACTS_BALANCE](state, data) {
    state.contractsBalance = data;
  },
  [types.SET_IS_LOAD_CONTRACT](state, status) {
    state.isLoad = status;
  },
  [types.SET_ACTIVE_CONTRACT](state, contractObject) {
    state.activeContract = contractObject;
  }
};

export const actions = {
  async fetchContracts({ commit }) {
    commit(types.SET_IS_LOAD_CONTRACT, true);

    try {
      const response = await getList(false);
      let { data } = response;
      commit(types.SET_CONTRACT, data);
    } catch (e) {
      console.error('Error fetching contracts:', e);
    } finally {
      commit(types.SET_IS_LOAD_CONTRACT, false);
    }
  },
  async fetchJoinedContracts({ commit }) {
    try {
      const response = await getList(true);
      let { data } = response;
      commit(types.SET_JOINED_CONTRACT, data);
    } catch (e) {
      console.error('Error fetching joined contracts:', e);
    }
  },

  async setActiveContract({ commit }, contractId) {
    try {
      const { data } = await setDefaultContract(contractId);
      if (data?.data) {


        commit(types.SET_ACTIVE_CONTRACT, data.data);
        return data.data;
      }
    } catch (e) {
      return null;
    }
  },
  async fetchContractsBalance({ commit }) {
    try {
      await contractsBalance().then(({ data }) => {
        commit(types.SET_CONTRACTS_BALANCE, data?.data);
      });
    } catch (e) {
      // commit(types.FETCH_USER_FAILURE);
    }
  },
  async fetchActiveContract({ commit }) {
    try {
      await getDefaultContract().then(({ data }) => {
        commit(types.SET_ACTIVE_CONTRACT, data?.data);
      });
    } catch (e) {
      // commit(types.FETCH_USER_FAILURE);
    }
  }
};




export const getters = {
  list: (state) => state.list,
  joined: (state) => state.joined,
  isLoad: (state) => state.isLoad,
  activeContract: (state) => state.activeContract,
  contractsBalance: (state) => state.contractsBalance,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  getContractBalance: (state) => (contractId) => {
    const contractBalance = state.contractsBalance?.find(b => b.id === contractId);
    return contractBalance ? contractBalance.balance : null;
  },
  getContract: (state) => (identifier) => {
    return state.list?.find(contract =>
      contract.id === identifier || contract.name === identifier
    ) ?? null;
  },
  getContractName: (state, getters) => (identifier) => {
    return getters.getContract(identifier)?.name;
  },
  getContractId: (state, getters) => (identifier) => {
    return getters.getContract(identifier)?.id;
  },
  currentUser: (state, getters) => (contractId, userId) => {
    const contract = getters.getContract(contractId);
    return contract?.users?.find(user => user.id === userId) ?? null;
  },
  userRoleId: (state, getters) => contractId => {
    return getters.currentUser(contractId)?.roleId;
  },
  userJoinedAt: (state, getters) => contractId => {
    return getters.currentUser(contractId)?.joinedAt;
  },
  ...entityStoreStatus.getters
};
